module.exports = __webpack_public_path__ + "static/andelfinger-zeitung-2f27f16e8ad1e2139cf95b4fdfc525f0.png";